export const FETCH_SNAPSHOT_MANAGEMENT =
  'ipfabric/SnapshotManagement/FETCH_SNAPSHOT_MANAGEMENT';
export const LOAD_SNAPSHOT = 'ipfabric/SnapshotManagement/LOAD_SNAPSHOT';
export const LOAD_SNAPSHOT_FINISH =
  'ipfabric/SnapshotManagement/LOAD_SNAPSHOT_FINISH';
export const UNLOAD_SNAPSHOT = 'ipfabric/SnapshotManagement/UNLOAD_SNAPSHOT';
export const UNLOAD_SNAPSHOT_FINISH =
  'ipfabric/SnapshotManagement/UNLOAD_SNAPSHOT_FINISH';
export const DELETE_SNAPSHOT = 'ipfabric/SnapshotManagement/DELETE_SNAPSHOT';
export const DELETE_SNAPSHOT_FINISH =
  'ipfabric/SnapshotManagement/DELETE_SNAPSHOT_FINISH';
export const DOWNLOAD_SNAPSHOT =
  'ipfabric/SnapshotManagement/DOWNLOAD_SNAPSHOT';
export const RUN_TOPOLOGY_CALCULATION =
  'ipfabric/SnapshotManagement/RUN_TOPOLOGY_CALCULATION';
export const UPLOAD_SNAPSHOT = 'ipfabric/SnapshotManagement/UPLOAD_SNAPSHOT';
export const UPLOAD_SNAPSHOT_FINISH =
  'ipfabric/SnapshotManagement/UPLOAD_SNAPSHOT_FINISH';
export const NOTE_CHANGE = 'ipfabric/SnapshotManagement/NOTE_CHANGE';
export const NAME_CHANGE = 'ipfabric/SnapshotManagement/NAME_CHANGE';
export const LOCK_SNAPSHOT = 'ipfabric/SnapshotManagement/LOCK_SNAPSHOT';
export const UNLOCK_SNAPSHOT = 'ipfabric/SnapshotManagement/UNLOCK_SNAPSHOT';
export const CLONE_SNAPSHOT = 'ipfabric/SnapshotManagement/CLONE_SNAPSHOT';
export const FETCH_HOSTNAME = 'ipfabric/SnapshotManagement/FETCH_HOSTNAME';
export const CLOSE_HOSTNAME = 'ipfabric/SnapshotManagement/CLOSE_HOSTNAME';
export const DELETE_DEVICE = 'ipfabric/SnapshotManagement/DELETE_DEVICE';
export const CANCEL_DISCOVERY_JOB_DIALOGUE_NAME =
  'ipfabric/SnapshotManagement/CANCEL_DISCOVERY_JOB_DIALOGUE_NAME';
export const SET_ACTIVE_MENU_TAB =
  'ipfabric/SnapshotManagement/SET_ACTIVE_MENU_TAB';
export const CLEAR_LOGS = 'ipfabric/SnapshotManagement/CLEAR_LOGS';
export const FETCH_LOGS = 'ipfabric/SnapshotManagement/FETCH_LOGS';
export const DELETE_DEVICE_FINISH =
  'ipfabric/SnapshotManagement/DELETE_DEVICE_FINISH';
export const DELETE_DEVICE_STOP =
  'ipfabric/SnapshotManagement/DELETE_DEVICE_STOP';
export const CLEAR_TABS = 'ipfabric/SnapshotManagement/CLEAR_TABS';
export const LOADING_STARTED = 'ipfabric/SnapshotManagement/LOADING_STARTED';
export const SAVE_DEVICES = 'ipfabric/SnapshotManagement/SAVE_DEVICES';
export const SHOW_REFRESH_LOADER =
  'ipfabric/SnapshotManagement/SHOW_REFRESH_LOADER';
export const SHOW_ADD_LOADER = 'ipfabric/SnapshotManagement/SHOW_ADD_LOADER';
export const FETCH_DEVICES = 'ipfabric/SnapshotManagement/FETCH_DEVICES';
export const CLEAR_DEVICES = 'ipfabric/SnapshotManagement/CLEAR_DEVICES';
export const CLEAR_INVENTORY = 'ipfabric/SnapshotManagement/CLEAR_INVENTORY';
export const OPEN_NEW_SETTINGS =
  'ipfabric/SnapshotManagement/OPEN_NEW_SETTINGS';
export const OPEN_SETTINGS = 'ipfabric/SnapshotManagement/OPEN_SETTINGS';
export const SNAPSHOT_PREVENT_DEVICE_LOAD =
  'ipfabric/SnapshotManagement/SNAPSHOT_PREVENT_DEVICE_LOAD';
export const SAVE_INVALID_PASSWORDS =
  'ipfabric/SnapshotManagement/SAVE_INVALID_PASSWORDS';
export const CLOSE_SETTINGS_NO_PASSWORDS =
  'ipfabric/SnapshotManagement/CLOSE_SETTINGS_NO_PASSWORDS';
export const FETCH_SITE_SEPARATION =
  'ipfabric/SnapshotManagement/FETCH_SITE_SEPARATION';
export const FETCH_DISCOVERY_TASKS =
  'ipfabric/SnapshotManagement/FETCH_DISCOVERY_TASKS';
export const DISCOVERY_TASKS_CHANGE =
  'ipfabric/SnapshotManagement/DISCOVERY_TASKS_CHANGE';
export const FETCH_DISABLED_POST_DISCOVERY_ACTIONS =
  'ipfabric/SnapshotManagement/FETCH_DISABLED_POST_DISCOVERY_ACTIONS';
export const DISABLED_POST_DISCOVERY_ACTIONS_CHANGE =
  'ipfabric/SnapshotManagement/DISABLED_POST_DISCOVERY_ACTIONS_CHANGE';

export const FETCH_SNAPSHOT_DATA =
  'ipfabric/SnapshotManagement/FETCH_SNAPSHOT_DATA';
export const CHANGE_SNAPSHOT = 'ipfabric/SnapshotManagement/CHANGE_SNAPSHOT';
export const BANDWIDTH_MSG_RECEIVED =
  'ipfabric/SnapshotManagement/BANDWIDTH_MSG_RECEIVED';
export const CLEAR_STATE = 'ipfabric/SnapshotManagement/CLEAR_STATE';
export const SNAPSHOT_INFO_RECEIVED =
  'ipfabric/SnapshotManagement/SNAPSHOT_INFO_RECEIVED';
export const SNAPSHOT_STATUS_RECEIVED =
  'ipfabric/SnapshotManagement/SNAPSHOT_STATUS_RECEIVED';
export const DISCOVERY_PROCESS_START =
  'ipfabric/SnapshotManagement/DISCOVERY_PROCESS_START';
export const DISCOVERY_PROCESS_STOP =
  'ipfabric/SnapshotManagement/DISCOVERY_PROCESS_STOP';
export const DOWNLOAD_LOG = 'ipfabric/SnapshotManagement/DOWNLOAD_LOG';
export const FETCH_DISCOVERY_INIT =
  'ipfabric/SnapshotManagement/FETCH_DISCOVERY_INIT';
export const NETWORKER_CONSOLE_CLEAR =
  'ipfabric/SnapshotManagement/NETWORKER_CONSOLE_CLEAR';
export const NETWORKER_LOGS_RECEIVED =
  'ipfabric/SnapshotManagement/NETWORKER_LOGS_RECEIVED';
export const NEW_DEVICE_SAVED = 'ipfabric/SnapshotManagement/NEW_DEVICE_SAVED';
export const SERVER_TS_RECEIVED =
  'ipfabric/SnapshotManagement/SERVER_TS_RECEIVED';
export const SET_SHAPER_SETTINGS =
  'ipfabric/SnapshotManagement/SET_SHAPER_SETTINGS';
export const TASKER_CONSOLE_CLEAR =
  'ipfabric/SnapshotManagement/TASKER_CONSOLE_CLEAR';
export const TASKER_LOGS_RECEIVED =
  'ipfabric/SnapshotManagement/TASKER_LOGS_RECEIVED';
export const ENABLE_START_BTN = 'ipfabric/SnapshotManagement/ENABLE_START_BTN';
export const DISABLE_START_BTN =
  'ipfabric/SnapshotManagement/DISABLE_START_BTN';
export const WORKER_CONSOLE_CLEAR =
  'ipfabric/SnapshotManagement/WORKER_CONSOLE_CLEAR';
export const WORKER_LAST_COMMUNICATION =
  'ipfabric/SnapshotManagement/WORKER_LAST_COMMUNICATION';
export const WORKER_LOGS_RECEIVED =
  'ipfabric/SnapshotManagement/WORKER_LOGS_RECEIVED';

export const DELETE_DIALOGUE_NAME = 'deleteSnapshot';
export const SETTINGS_NO_PASSWORD_DIALOGUE_NAME = 'settingsNoPassword';
export const PAGE_URL = '/snapshot-management';

export const RUNNING_DISCOVERY_STATUSES = ['ready', 'run', 'finishing'];
export const LOADED_STATES = ['loaded', 'loading', 'discovering'];
export const UNLOADED_STATES = ['unloaded', 'unloading'];

export const SNAPSHOT_LOADED = 'loaded';
export const SNAPSHOT_UNLOADED = 'unloaded';

export const MENU_TAB_FILTERS = 'snapshots_filters';
export const INVENTORY_TABLE_NAME = 'snapshots-detail-inventory';
export const TASKS_STATUSES_DISABLE_REDISCOVERY = ['ok', 'found'];

export const SNAPSHOT_ID_LS_KEY = 'ipf/snapshotId';
